import { defineNuxtPlugin } from '#app'
import JsonEditorVue from 'json-editor-vue'

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.component("json-editor-vue", JsonEditorVue)
})